import {
  CardSystem,
  isCardSystem,
  CardIssuer,
  isCardIssuer,
  RecurrentBankCard,
  RecurrentBankCardParams,
} from 'app/dataTypes/acquiring/recurrent/cards'

import type { Request } from '../../../index'

type ApiResult = Array<{
  id: number
  card_number: string //            последние 4 цифры карты
  card_country_code: string //      страна выпуска (ru)
  card_issuer: string | null
  card_system: 'visa' | 'mastercard' | 'mir' | 'unionpay' | 'jcb' | 'other' | string | null
}>

type ApiParams = {
  accountable_type: 'Parent' | 'Student'
  accountable_id: number
  service: 'primary' | 'cafeteria' | 'camp'
}

export const convertResult = (result: ApiResult): Array<RecurrentBankCard> => {
  return result.map(
    ({
      id,
      card_number: cardNumber,
      card_country_code: cardCountryCode,
      card_issuer: cardIssuer,
      card_system: cardSystem,
    }) => {
      const cardIssuerNormalized = cardIssuer
        ? cardIssuer.replace(/\s|"|'|»|«|“|”|-|_/g, '').toLowerCase()
        : ''
      return {
        id: String(id),
        lastFourDigits: cardNumber,
        countryCode: cardCountryCode,
        issuer: isCardIssuer(cardIssuerNormalized) ? cardIssuerNormalized : CardIssuer.Unknown,
        system: cardSystem && isCardSystem(cardSystem) ? cardSystem : CardSystem.Other,
      }
    },
  )
}

export const convertParams = ({
  id,
  ownerType,
  refillType,
}: RecurrentBankCardParams): [ApiParams, null] => {
  return [
    {
      accountable_type: ownerType,
      accountable_id: parseInt(id, 10),
      service: refillType,
    },
    null,
  ]
}

export const GET_ACQUIRING_SAVED_BANK_CARDS: Request<void, Array<RecurrentBankCard>, void> = [
  'payments/acquiring2/saved_bank_cards',
  'get',
  ['data', 'cards'],
]
